import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { PButtonModule } from '@panaya/ui/p-button';
import { PFieldTextModule } from '@panaya/ui/p-field-text';
import { PIconModule } from '@panaya/ui/p-icon';
import { PChipGroupModule } from '../../p-hashtag/p-chip-group';
import { PFieldModule } from '../p-field.module';
import { PFieldMultiSelectComponent } from './p-field-multi-select.component';

@NgModule({
    declarations: [PFieldMultiSelectComponent],
    imports: [
        CommonModule,
        PIconModule,
        PFieldTextModule,
        PButtonModule,
        MatMenuModule,
        PFieldModule,
        PChipGroupModule,
        MatTooltipModule,
        MatFormFieldModule,
        TranslateModule,
        ReactiveFormsModule,
        FormsModule
    ],
    exports: [PFieldMultiSelectComponent]
})
export class PFieldMultiSelectModule {}
